import "./App.css";

//PACKAGES
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PostHogProvider, PostHogErrorBoundary } from "posthog-js/react";

//SCREENS
import PageRouter from "./lzapp_web_common_code/components/Router";
import { AppProvider } from "./lzapp_web_common_code/context/AppProvider";
import { AuthProvider } from "./lzapp_web_common_code/context/AuthProvider";
import { BundleProvider } from "./lzapp_web_common_code/context/BundleProvider";
import { ContentProvider } from "./lzapp_web_common_code/context/ContentProvider";
import { AnalyticsProvider } from "./lzapp_web_common_code/context/AnalyticsProvider";
import { ThemeProvider } from "./lzapp_web_common_code/context/ThemeProvider";
import { useEffect, useState } from "react";
import React from "react";
import { APP_BUNDLES } from "./app_constant";
import { COLORS, COLORS_DARK } from "./lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "./lzapp_web_common_code/constant/event";
import Loader from "./lzapp_web_common_code/components/loader";
import MobileAppBanner from "./lzapp_web_common_code/components/common/MobileAppBanner";

// Error fallback UI for PostHogErrorBoundary
const ErrorFallback = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '2rem',
    textAlign: 'center',
    backgroundColor: '#f9fafb',
    color: '#374151'
  }}>
    <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>
      Something went wrong
    </h1>
    <p style={{ marginBottom: '2rem', color: '#6b7280' }}>
      We're sorry, but something went wrong. Please refresh the page and try again.
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{
        padding: '0.75rem 1.5rem',
        backgroundColor: '#3b82f6',
        color: 'white',
        border: 'none',
        borderRadius: '0.5rem',
        cursor: 'pointer',
        fontSize: '1rem'
      }}
    >
      Refresh Page
    </button>
  </div>
);

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Function to get query parameters
    const getQueryParams = () => {
        const params = new URLSearchParams(window.location.search);
        return {
            promo_code: params.get('promo_code')
        };
    };

    // Capture the promo code from the URL
    const queryParams = getQueryParams();
    if (queryParams.promo_code) {
        localStorage.setItem('promo_code', queryParams.promo_code);
    }
  }, []);

  useEffect(() => {}, [localStorage.getItem("SAVED_BUNDLE_DETAILS")]);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        await setThemeColor();
        // Only show loader for actual initialization time, not arbitrary 1 second
        setLoading(false);
      } catch (error) {
        console.error('App initialization error:', error);
        setLoading(false);
      }
    };

    initializeApp();
  }, []);

  async function setThemeColor() {
    const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
    if (result) {
      const selectedBundles = APP_BUNDLES.filter((e) => e.key == result);
      if (selectedBundles.length > 0) {
        COLORS.THEME_DARK = selectedBundles[0].THEME_DARK;
        COLORS.THEME_LIGHT = selectedBundles[0].THEME_LIGHT;
        COLORS.THEME_SCORE_CONTAINER = selectedBundles[0].THEME_BORDER;
        COLORS.THEME_PREMIUM_BACKGROUND = selectedBundles[0].PREMIUM_BACKGROUND;
        COLORS_DARK.THEME_DARK = selectedBundles[0].THEME_DARK_MODE;
        COLORS_DARK.THEME_LIGHT = selectedBundles[0].THEME_LIGHT_DARK_MODE;
        COLORS_DARK.THEME_SCORE_CONTAINER =
          selectedBundles[0].THEME_BORDER_DARK_MODE;
        COLORS_DARK.THEME_PREMIUM_BACKGROUND =
          selectedBundles[0].PREMIUM_BACKGROUND_DARK_MODE;
      } else {
        COLORS.THEME_DARK = APP_BUNDLES[0].THEME_DARK;
        COLORS.THEME_LIGHT = APP_BUNDLES[0].THEME_LIGHT;
        COLORS.THEME_SCORE_CONTAINER = APP_BUNDLES[0].THEME_BORDER;
        COLORS.THEME_PREMIUM_BACKGROUND = APP_BUNDLES[0].PREMIUM_BACKGROUND;

        COLORS_DARK.THEME_DARK = APP_BUNDLES[0].THEME_DARK_MODE;
        COLORS_DARK.THEME_LIGHT = APP_BUNDLES[0].THEME_LIGHT_DARK_MODE;
        COLORS_DARK.THEME_SCORE_CONTAINER =
          APP_BUNDLES[0].THEME_BORDER_DARK_MODE;
        COLORS_DARK.THEME_PREMIUM_BACKGROUND =
          APP_BUNDLES[0].PREMIUM_BACKGROUND_DARK_MODE;
      }
    } else {
      COLORS.THEME_DARK = APP_BUNDLES[0].THEME_DARK;
      COLORS.THEME_LIGHT = APP_BUNDLES[0].THEME_LIGHT;
      COLORS.THEME_SCORE_CONTAINER = APP_BUNDLES[0].THEME_BORDER;
      COLORS.THEME_PREMIUM_BACKGROUND = APP_BUNDLES[0].PREMIUM_BACKGROUND;

      COLORS_DARK.THEME_DARK = APP_BUNDLES[0].THEME_DARK_MODE;
      COLORS_DARK.THEME_LIGHT = APP_BUNDLES[0].THEME_LIGHT_DARK_MODE;
      COLORS_DARK.THEME_SCORE_CONTAINER = APP_BUNDLES[0].THEME_BORDER_DARK_MODE;
      COLORS_DARK.THEME_PREMIUM_BACKGROUND =
        APP_BUNDLES[0].PREMIUM_BACKGROUND_DARK_MODE;
    }
  }
  return (
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
        capture_pageview: false,
        capture_pageleave: false,
        autocapture: false,
        capture_performance: false,
        loaded: (posthog) => {
          // Register super properties immediately on load so they're
          // attached to every event, including early ones fired before
          // AnalyticsProvider's useEffect runs.
          const { BUNDLE_APP_NAME, GET_APP_NAME } = require('./app_constant');
          const selectedCertificate = localStorage.getItem('selectedCertificate') || 'cisa';
          posthog.register({
            app_name: BUNDLE_APP_NAME,
            exam_name: GET_APP_NAME(selectedCertificate),
            platform: 'web',
            source_environment: process.env.NODE_ENV || 'production',
          });
        },
      }}
    >
      <BundleProvider>
        <ContentProvider>
          <AuthProvider>
            <ThemeProvider>
              <AppProvider>
                <BrowserRouter>
                  <HelmetProvider>
                    <AnalyticsProvider>
                      <PostHogErrorBoundary fallback={<ErrorFallback />}>
                        <MobileAppBanner />
                        {loading ? <Loader /> : <PageRouter />}
                      </PostHogErrorBoundary>
                    </AnalyticsProvider>
                  </HelmetProvider>
                </BrowserRouter>
              </AppProvider>
            </ThemeProvider>
          </AuthProvider>
        </ContentProvider>
      </BundleProvider>
    </PostHogProvider>
  );
}

export default App;
